const isWebsiteLoadedInIframe = window.self !== window.top;

export default isWebsiteLoadedInIframe;
